import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilsService } from './utils.service';

export type SearchFilterType = 'all' | 'cases' | 'customers' | 'rules' | 'users';

export interface SearchResult {
  id: string;
  name: string;
  type: 'case' | 'customer' | 'rule' | 'user';
  url: string;
  metadata: Record<string, string>;
}

export interface SearchResponse {
  results: SearchResult[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class SearchService {
  private httpClient = inject(HttpClient);
  private utilsService = inject(UtilsService);

  search(q: string, type: SearchFilterType = 'all'): Observable<SearchResponse> {
    const apiUrl = this.utilsService.buildApiUrl(`search/`);
    return this.httpClient.get<SearchResponse>(apiUrl, {
      params: { q, type }
    });
  }
}
